import React from 'react';
import LegalDocumentView from '../components/Legal/LegalDocumentView';

const ProviderTerms = () => (
  <LegalDocumentView type="PROVIDER_TERMS" title="Partneri Általános Szerződési Feltételek" />
);

export default ProviderTerms;
